// Pure helpers behind TagListInput: the chip list reads and writes the same
// newline-joined string the config drafts use for string_array fields.

// Splits typed or pasted text into values: commas, whitespace and newlines all
// separate, so "AA:.., BB:.." and a pasted column both work.
export function splitTags(text: string): string[] {
  return text
    .split(/[\s,;]+/)
    .map((t) => t.trim())
    .filter((t) => t !== "");
}

export function tagsFromValue(value: string): string[] {
  return value
    .split("\n")
    .map((t) => t.trim())
    .filter((t) => t !== "");
}
